export default function () {
	document.addEventListener("DOMContentLoaded", () => {
		const tooltip = document.createElement("div");
		const classNames = {
			base: 'webixa-tooltip',
			active: 'webixa-tooltip-active',

		}
		tooltip.className = classNames.base;
		document.body.appendChild(tooltip);

		let activeTarget = null;

		function showTooltip(e) {
			const text = e.target.getAttribute("data-tooltip");
			if (!text) return;

			tooltip.textContent = text;
			tooltip.classList.add(classNames.active);
			activeTarget = e.target;
			positionTooltip(e);
		}

		function hideTooltip() {
			tooltip.classList.remove(classNames.active);
			activeTarget = null;
		}

		function positionTooltip(e) {
			if (!activeTarget) return;

			const rect = activeTarget.getBoundingClientRect();
			const top = rect.top + window.scrollY - tooltip.offsetHeight - 8;
			const left = rect.left + window.scrollX + rect.width / 2 - tooltip.offsetWidth / 2;

			tooltip.style.top = `${top}px`;
			tooltip.style.left = `${left}px`;
		}

		document.addEventListener("mouseover", showTooltip, true);
		document.addEventListener("mouseout", hideTooltip, true);
		document.addEventListener("mousemove", positionTooltip, true);
	});

}